/**
 * Brand constants for Guidance Angel — Jenika Bhayani
 * Update image URLs to point to your actual hosted assets.
 */

export const BRAND = {
  name: "Guidance Angel",
  tagline: "Tarot · Numerology · Akashic",
  founder: "Jenika Bhayani",
  yearsExperience: 7,
  clientsGuided: 10000,
  googleReviews: 205,
  igTestimonials: 1000,

  // ── Contact ──────────────────────────────────────────────────────────────
  whatsapp: "918320135858",          // digits only, with country code
  whatsappPretty: "+91 83201 35858",
  phone: "+918320135858",
  email: "guidance.angel7@gmail.com",
  instagram: "https://www.instagram.com/guidance_angel7",

  // ── Images ────────────────────────────────────────────────────────────────
  // These point to files inside your frontend/public/ folder.
  // Upload logo.png and jenika.jpg to that folder on GitHub and you're done.
  logoRound:   "/logo.png",
  heroBackdrop: "",   // optional soft backdrop behind hero – leave blank to hide
  jenikaPhoto: "/jenika.jpg",
};

export const TRUST_STATS = [
  { value: "10,000+", label: "Seekers Guided" },
  { value: "7+",      label: "Years of Practice" },
  { value: "4.9★",  label: "Average Rating" },
  { value: "6+",    label: "Modalities Offered" },
];

export const GALLERY = [
  {
    src: "/gallery1.jpg",
    label: "Live Session",
    caption: "One-on-one soul readings",
  },
  {
    src: "/gallery2.jpg",
    label: "Workshop",
    caption: "Speaking to hundreds with clarity",
  },
  {
    src: "/gallery3.jpg",
    label: "Healing Circle",
    caption: "Guiding group energy journeys",
  },
];

export const FAQS = [
  {
    q: "How does an online tarot reading work?",
    a: "After booking, you receive a confirmation with the session link (Google Meet / Zoom). At the scheduled time, Jenika connects with your energy and reads the cards for you live. For voice-note readings, your answer is recorded and sent within 48 hours.",
  },
  {
    q: "What information do I need to share before a reading?",
    a: "For numerology and Akashic readings your full birth date is needed. For tarot, just your name and intention. Jenika does NOT need your birth time or horoscope — she reads intuitively.",
  },
  {
    q: "How accurate are the readings?",
    a: "Hundreds of clients have called their readings 90–100% accurate. The cards reflect the energy at the time of reading. Your free will can shift outcomes — readings show potentials, not fixed futures.",
  },
  {
    q: "Can I ask about a specific person (partner, boss, family)?",
    a: "Yes. Jenika can read the energy dynamics between you and another person without that person being present, using your shared energetic field.",
  },
  {
    q: "What happens if I miss my scheduled session?",
    a: "Please WhatsApp Jenika at least 2 hours before your slot. Missed sessions without notice are not rescheduled. With prior notice, one reschedule is offered.",
  },
  {
    q: "Do the physical products (candles, crystals) ship all over India?",
    a: "Yes — all products ship pan-India via courier. Delivery takes 5–7 business days. Each item is cleansed and charged before dispatch.",
  },
  {
    q: "Is payment secure?",
    a: "Payments are processed via Razorpay — a PCI-DSS compliant gateway. Your card details are never stored on our servers.",
  },
];
